import { ICoordinates } from './geo';
import { IInfrastructureCategory } from 'shared/types/infrastructure';

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EOfferType {
  /** коммерческая **/
  Commercial = 'commercial',
  /** квартиры **/
  Flat = 'flat',
  /** новостройки **/
  Newobject = 'newobject',
  /** загородка **/
  Suburban = 'suburban',
}

export interface IMapFragmentProps {
  apiKey: string;
  suggestApiKey: string;
  coordinates?: ICoordinates;
  houseId: number;
  regionId: number;
  infrastructureCategories?: IInfrastructureCategory[] | null;
}
